import { useAuthQuery } from '@/services/auth';
import { PageLoader } from '@customerio/pluma-components/react';
import { McpOauth2 } from '@/features/mcp/oauth2/index';
import { useLocation } from 'react-router-dom';
import { NotFoundPage } from './not-found';
import { Navigate } from '@/utils/navigate';

const Oauth2Routes = {
  Mcp: '/oauth2/mcp',
} as const;

export function OAuth2() {
  const auth = useAuthQuery();
  const { pathname } = useLocation();

  if (auth.isLoading) {
    return <PageLoader label="Please wait..." />;
  }

  if (auth.data == null || auth.data?.account == null || auth.data?.user == null) {
    return <Navigate to="/login" saveCurrentUrl={true} />;
  }

  switch (pathname) {
    case Oauth2Routes.Mcp:
      return <McpOauth2 canEditAccount={auth.data.user.account_permissions?.includes('account/edit')} />;
    default:
      return <NotFoundPage />;
  }
}
